export default {
    C: "Do",
    CSharp: "Do♯",
    D: "Re",
    DFlat: "Re♭",
    DSharp: "Re♯",
    E: "Mi",
    EFlat: "Mi♭",
    F: "Fa",
    FSharp: "Fa♯",
    G: "Sol",
    GFlat: "Sol♭",
    GSharp: "Sol♯",
    A: "La",
    AFlat: "La♭",
    ASharp: "La♯",
    B: "Si",
    BFlat: "Si♭",
  
    correctExcl: "Giusto!",
    wrongExcl: "Sbagliato!",
  
    ABORT: "Esci",
  
    lastRound: "Ultimo turno",
    score: "Punti",
    accuracy: "Precisione",
    correct: "Corretto",
    wrong: "Sbagliato",
  
    START: "START",
    settings: "Opzioni",
    ROUND_LENGTH: "DURATA ROUND",
    NOTE_INPUT: "INSERIMENTO NOTE",
    CLEF: "CHIAVE",
    DIFFICULTY: "GRADO DI DIFFICOLTÀ",
    ACCIDENTALS: "ALTERAZIONI",
    LANGUAGE: "LINGUA",
    twentySeconds: "20 s",
    oneMinute: "1 min",
    fiveMinutes: "5 min",
    infinite: "Infinito",
    buttons: "Pulsanti",
    piano: "Pianoforte",
    trebleClef: "Violino",
    bassClef: "Basso",
    altoClef: "Alto",
    tenorClef: "Tenore",
    easy: "Facile",
    normal: "Medio",
    hard: "Difficile",
    none: "Nessuno",
    sharp: "♯",
    flat: "♭",
    sharpAndFlat: "♯ e ♭",
    SOUND: "SUONO",
    VIBRATION: "VIBRAZIONE",
    DISPLAYCORRECTNOTE: "VISUALIZZARE LA NOTA CORRETTA",
    on: "Si",
    off: "No",
  
    TIME: "TEMPO",
    CORRECT: "CORRETTI",
    ACCURACY: "PRECISIONE",
    SCORE: "PUNTEGGIO",
  
    record: "Record",
    history: "Storico",
  
    noMidiSupport: "Spiacente, sembrerebbe che il tuo dispositivo non supporti il MIDI",
    noDeviceFound: "Nessun dispositivo individuato. Reinserisci il dispositivo MIDI.",
    playTheNote: "Suona le note sulla tua tastiera MIDI.",
    lastNotePlayed: "Ultima nota suonata",
  };


// WEBPACK FOOTER //
// ./src/resources/it.js